import { create } from 'zustand';

export interface Toast {
  id: number;
  msg: string;
  type: 'success' | 'warn';
}
interface ToastState {
  toasts: Toast[];
  push: (msg: string, type?: 'success' | 'warn') => void;
}
let seq = 1;
export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (msg, type = 'success') => {
    const id = seq++;
    set((s) => ({ toasts: [...s.toasts, { id, msg, type }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 3200);
  },
}));
